var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Link } from 'react-router-dom';
import { EventRole } from 'src/imports/server-main/authorization.enum';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Divider from 'antd/lib/divider';
import 'antd/lib/divider/style/index.css';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var CardExplanation = (function (_super) {
    __extends(CardExplanation, _super);
    function CardExplanation(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            role: EventRole.Organizer,
        };
        _this.handleUpdateRole = _this.handleUpdateRole.bind(_this);
        return _this;
    }
    CardExplanation.prototype.handleUpdateRole = function (value) {
        this.setState({ role: value });
    };
    CardExplanation.prototype.render = function () {
        var role = this.state.role;
        return (React.createElement(Card, { className: this.props.className },
            React.createElement("p", null, "You can manage the roles for your organizing team here."),
            React.createElement("p", null,
                "You can have them join the team for your event by sending them the link, ",
                React.createElement(Link, { to: 'http://android.crimp.rocks' }, "android.crimp.rocks"),
                " or ",
                React.createElement(Link, { to: 'http://ios.crimp.rocks' }, "ios.crimp.rocks"),
                ", via email or text message. It will guide them to sign up for the app for judges, and this platform for your admins."),
            React.createElement(Divider, null),
            React.createElement("h4", null, "Explanation of Role:"),
            React.createElement(Select, { onChange: this.handleUpdateRole, style: { width: '100%' }, value: this.state.role },
                React.createElement(Select.Option, { value: EventRole.Organizer }, "Organizer"),
                React.createElement(Select.Option, { value: EventRole.Judge }, "Judge (Active)"),
                React.createElement(Select.Option, { value: EventRole.JudgePending }, "Judge (Request!)"),
                React.createElement(Select.Option, { value: EventRole.JudgeInactive }, "Judge (Inactive)"),
                React.createElement(Select.Option, { value: EventRole.Pending }, "Role request!"),
                React.createElement(Select.Option, { value: EventRole.Blocked }, "No Role")),
            React.createElement("p", null, role === EventRole.Organizer
                ? 'This is your core team member. An organizer will have access to everything. Only grant this role to the most trusted members of your team.'
                : role === EventRole.Judge
                    ? 'A judge is one of your volunteers/team members who are responsible for recording the scores at the climbing wall'
                    : role === EventRole.JudgePending
                        ? 'Ignore this, this role is for a feature that\'s in the works!'
                        : role === EventRole.JudgeInactive
                            ? 'An "inactive" judge is one of your volunteers/team members who isn\'t scheduled for duties'
                            : role === EventRole.Pending
                                ? 'This is a person that has requested for access. '
                                : role === EventRole.Blocked
                                    ? 'This is a person that you do not want to grant access for.'
                                    : 'No such role...'),
            React.createElement("li", null,
                React.createElement("strong", null, role >= EventRole.Organizer ? 'Allowed' : 'Not allowed'),
                " to set roles for other users in the event"),
            React.createElement("li", null,
                React.createElement("strong", null, role >= EventRole.Organizer ? 'Allowed' : 'Not allowed'),
                " to see event/athlete data on this platform"),
            React.createElement("li", null,
                React.createElement("strong", null, role >= EventRole.Organizer ? 'Allowed' : 'Not allowed'),
                " to create and edit event/athlete data on this platform"),
            React.createElement("li", null,
                React.createElement("strong", null, role >= EventRole.Judge ? 'Allowed' : 'Not allowed'),
                " to edit scores on the judge app"),
            React.createElement("li", null,
                React.createElement("strong", null, role === EventRole.JudgeInactive ? 'Allowed' : 'Not allowed'),
                " to request permission to edit scores on the judge app")));
    };
    return CardExplanation;
}(React.Component));
export default CardExplanation;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListUserEventRolePage/CardExplanation.tsx
// module id = 1083
// module chunks = 0